<template>
  <div class="register">
    <header>
      <div class="content-continer">
        <div class="left">
          <p class="logo">
            <img src="../assets/logo.png" />
          </p>
          <span class="logo-fl">医院注册</span>
        </div>
        <div class="right login-link">
          <router-link to="/login-hospital">
            <span style="color: #666;">已有账号?</span>
            <span style="color:red; margin-left: 10px;">请登陆></span>
          </router-link>
        </div>
      </div>
    </header>
    <!-- 第一步 -->

    <div class="sed-register steps" v-show="first">
    <!-- <div class="sed-register steps" v-show="false"> -->
      <ul class="steps-top">
        <li>
          <img src="../assets/hospital-img/icon2-2.png" />
          <p>填写账号信息</p>
        </li>
        <li>
          <img src="../assets/hospital-img/icon1-w.png" />
          <p>验证手机号码</p>
        </li>

        <li>
          <img src="../assets/hospital-img/icon1-3.png" />
          <p>注册成功</p>
        </li>
      </ul>
      <div class="step-border"></div>
      
      <div>
        <form class="forms">
          <p>
            <span>医院名称</span>
            <input type="text" placeholder="请输入医院名称" v-model="hospitalName" />
          </p>
          <p>
            <span>备案邮箱</span>
            <input type="text" placeholder="请输入在药物临床试验登记与信息公示平台登记备案的邮箱" v-model="email" />
          </p>
          <p>
            <span>联系人</span>
            <input type="text" placeholder="请输入联系人" v-model="contactName" />
          </p>
          <p>
            <span>联系电话</span>
            <input type="text" placeholder="请输入联系电话" v-model="contactMobile" />
          </p>
          <p>
            <span>资格证书</span>
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              name="fileName"
            >
              <img v-if="imageUrl" :src="imgurl+imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </p>
          <p>
            <a class="next-btn" @click="sedajax">下一步</a>
          </p>
        </form>
      </div>
    </div>
    <!-- 第二步 -->
    <div class="fisrt-register steps" v-show="sed">
    <!-- <div class="fisrt-register steps" v-show="true"> -->
      <ul class="steps-top">
        <li>
          <img src="../assets/hospital-img/icon2-2.png" />
          <p>填写账号信息</p>
        </li>
        <li>
          <img src="../assets/hospital-img/icon1-1.png" />
          <p>验证手机号码</p>
        </li>

        <li>
          <img src="../assets/hospital-img/icon1-3.png" />
          <p>注册成功</p>
        </li>
      </ul>
      <div class="step-border"></div>
      <div>
        <form class="forms">
          <p>
            <span>用户名</span>
            <input type="text" placeholder="请设置登陆用户名" v-model="loginName" />
          </p>
          <p>
            <span>手机号码</span>
            <input type="text" placeholder="请输入手机号" v-model="mobile" />
          </p>
          <p>
            <span class="input-text">图形码</span>
            <input type="text" class="code" placeholder="输入验证码" v-model="imgcodeinput" />
            <img :src="imgCode" style="vertical-align:middle;margin-left: 20px;" @click="Refresh" />
          </p>
          <p>
            <span class="input-text">验证码</span>
            <input type="text" class="code" placeholder="输入验证码" v-model="smsCode" />
            <a class="codebtn" @click="send" v-if="Verification">获取验证码</a>
            <a class="codebtn nobtn" v-if="!Verification">{{time}}s后重新获取</a>
          </p>
          <p>
            <span>密码</span>
            <input type="password" placeholder="请输入密码" v-model="pwd" />
          </p>
          <p>
            <el-checkbox v-model="checked">
              我接受
              <span class="blue">用户协议</span>和
              <span class="blue">隐私政策</span>
            </el-checkbox>
          </p>
          <p>
            <a class="next-btn" @click="thirdajax">下一步</a>
          </p>
        </form>
      </div>
    </div>

    <!-- 第三步 -->
    <div class="sed-register steps" v-show="third">
      <ul class="steps-top">
        <li>
          <img src="../assets/hospital-img/icon1-1.png" />
          <p>验证手机号码</p>
        </li>
        <li>
          <img src="../assets/hospital-img/icon2-2.png" />
          <p>填写账号信息</p>
        </li>
        <li>
          <img src="../assets/hospital-img/icon3-3.png" />
          <p>注册成功</p>
        </li>
      </ul>
      <div class="step-border"></div>
      <div class="success center">
        <img src="../assets/hospital-img/icon-success.png" />
        <p class="blue sucess-font">恭喜，注册完成</p>
        <p>您的注册申请已经提交，7个工作日内通过审核后，将可登录使用！</p>
        <p>如未接到通知，请及时联系010--86463913</p>
      </div>
      <div class="center return-home">
        <router-link to="/" class="blue">返回首页</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { orgExist } from "@/request/api";
import { sedcode } from "@/request/api";
import { hospitalRes } from "@/request/api";
import { getSmsCode } from "@/request/api";
import { getImgcode } from "@/request/api";

export default {
  name: "register",
  data() {
    return {
      action: this.Common.serverSrc,
      first: true,
      sed: false,
      third: false,
      checked: true,
      contactMobile: "",
      contactName: "",
      value: "",
      imageUrl: "",
      imgurl: this.Common.imgurl,
      hospitalName: "",
      email: "",
      mobile: "",
      loginName: '',
      pwd: "",
      pwdq: "",
      code: "",
      smsCode: "",
      codeurl: this.Common.codeurl,
      imgCode: this.Common.codeurl,
      imgcodeinput: "",
      Verification: true,
      time: 60,
      auth_timer: null
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      this.imageUrl = res.fileName;
      console.log(res.fileName);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    // 第一步信息验证处理
    // 去除空格
    removeAllSpace(str) {
      return str.replace(/\s+/g, "");
    },

    // 医院名称验证
    firstNameCheck() {
      if (this.hospitalName) {
        let tempProjectDesc = this.removeAllSpace(this.hospitalName);
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/;
        if (
          myregNum.test(tempProjectDesc) ||
          myregParti.test(tempProjectDesc)
        ) {
          this.$message.error("医院名称不合法：请勿输入纯数字或者纯特殊字符");
        } else {
          return true;
        }
      } else {
        this.$message.error("请输入医院名称");
        return false;
      }
    },
    // 备案邮箱验证
    firstEmailCheck() {
      if (this.email) {
        let tempEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (!tempEmail.test(this.email)) {
          this.$message.error("邮箱格式错误，请重新输入");
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    // 资格证书验证
    firstProveCheck() {
      if (this.imageUrl) {
        return true;
      } else {
        this.$message.error("请上传资格证书");
        return false;
      }
    },

    sedajax() {
      
      if (
        this.hospitalName == "" ||
        this.email == "" ||
        this.imageUrl == "" ||
        this.contactName == "" ||
        this.contactMobile == ""
      ) {
        this.$message.error("所有信息为必填");
      } else if (
        !(
          this.firstNameCheck() &&
          this.firstEmailCheck() &&
          this.firstProveCheck()
        )
      ) {
        console.log("参数验证不通过");
      } else {
        orgExist(this.hospitalName)
          .then(res => {
            console.log(res.data.code);
            if (res.data.code == "00000") {
              this.first = false;
              this.sed = true;
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    // 验证 - 手机号 - 图形码 - 验证码 - 密码

    // (1) 手机号码验证处理
    thirdCheckMobile() {
      if (this.mobile) {
        if (/^[1][3,4,5,7,8][0-9]{9}$/.test(this.mobile)) {
          return true;
        } else {
          this.$message.error("手机号码格式不正确");
          return false;
        }
      } else {
        this.$message.error("请输入手机号码");
        return false;
      }
    },

    // (2) 图形验证码的处理
    thirdCheckPic() {
      if (this.imgcodeinput) {
        return true;
      } else {
        this.$message.error("请输入图形验证码");
        return false;
      }
    },
    // (3) 短信验证码的处理
    thirdCheckSms() {
      if (this.smsCode) {
        return true;
      } else {
        this.$message.error("请输入短信验证码");
        return false;
      }
    },
    // (4) 密码验证的处理
    thirdCheckPwd() {
      if ((/^[0-9]+\.{0,1}[0-9]{0,2}$/.test(this.pwd)) || (/^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/.test(this.pwd))) {
        return true;
      } else {
        this.$message.error('请勿使用纯字母或者纯数字的密码');
        return false;
      }
    },

    thirdajax() {
      if (this.checked == false) {
        this.$message.error("请选择用户协议");
      } else if (this.mobile == "" || this.smsCode == "" || this.pwd == "" || this.loginName == "") {
        this.$message.error("所有信息为必填");
      } else if (
        !(
          this.thirdCheckMobile() &&
          this.thirdCheckPic() &&
          this.thirdCheckSms() &&
          this.thirdCheckPwd()
        )
      ) {
        console.log("验证不通过");
      } else {
        let data = {
          code: this.smsCode,
          email: this.email,
          imgUrl: this.imageUrl,
          mobile: this.mobile,
          orgName: this.hospitalName,
          password: this.pwd,
          contactMobile: this.contactMobile,
          contactName: this.contactName,
          loginName: this.loginName,
        };
        console.log(data);
        hospitalRes(data)
          .then(res => {
            console.log(res.data.code);
            if (res.data.code == "00000") {
              this.sed = false;
              this.third = true;
              this.$message({
                message: msg,
                type: "注册成功"
              });
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    Refresh() {
      // getImgcode().then((res)=>{
      //   console.log(res)
      // })
      let num = Math.ceil(Math.random() * 10);
      this.imgCode = this.codeurl + "?" + num;
    },
    // 发送验证码
    send() {
      if (this.mobile == "" || this.imgcodeinput == "") {
        this.$message.error("手机号码或图形验证码不能为空");
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
          this.$message.error("手机号码格式错误");
        } else {
          let data = {
            codeType: "1",
            imgCode: this.imgcodeinput,
            mobile: this.mobile
          };
          console.log(data.imgCode);
          getSmsCode(data)
            .then(res => {
              let msg = res.data.message;
              if (res.data.code == "00000") {
                this.$message({
                  message: msg,
                  type: "success"
                });
                // 倒计时
                this.Verification = false; //点击button改变v-show的状态
                this.auth_timer = setInterval(() => {
                  //定时器设置每秒递减
                  this.time--; //递减时间
                  if (this.time <= 0) {
                    this.Verification = true; //60s时间结束还原v-show状态并清除定时器
                    clearInterval(this.auth_timer);
                    this.auth_timer = null;
                    this.time = 60;
                  }
                }, 1000);
              } else {
                this.$message.error(msg);
              }
              this.Refresh();
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.register header {
  width: 100%;
  height: 70px;
  line-height: 70px;
  border: 2px solid rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 21px 0px rgba(202, 202, 202, 0.4);
  box-sizing: border-box;
}

.logo img {
  vertical-align: middle;
}

.logo,
.logo-fl,
.logo-name {
  float: left;
}

.logo-name {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular;
  font-weight: bold;
  color: rgba(55, 113, 202, 1);
  margin-left: 14px;
}

.logo-fl {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: rgba(77, 77, 77, 1);
  margin-left: 28px;
}

.login-link a {
  color: #4a88d3;
}

.steps {
  position: relative;
  width: 1100px;
  height: 500px;
  margin-top: 60px;
}

.trans-center {
  position: relative;
  left: 50%;
  transform: translate(-50%);
}

.steps {
  width: 704px;
  position: relative;
  left: 50%;
  transform: translate(-50%);
}

.steps-top {
  z-index: 5;
  position: relative;
  height: 100px;
}

.steps-top li {
  float: left;
  margin: 0 80px;
  height: 60px;
  text-align: center;
}

.steps li p {
  margin-top: 17px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: rgba(77, 77, 77, 1);
}

.step-border {
  position: absolute;
  top: 20px;
  left: 150px;
  /* height:2px; */
  width: 420px;
  border-bottom: dashed 1px #b8b8b8;
  z-index: 0;
}

.forms {
  width: 410px;
  margin: 0 auto;
  margin-top: 60px;
}

.fisrt-register input {
  width: 300px;
}

.forms p {
  margin-bottom: 35px;
}

.forms p > span {
  display: inline-block;
  width: 80px;
  text-align: left;
  color: #666666;
  /* font-weight: bold; */
}

.code {
  width: 180px !important;
}

.codebtn {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(173, 204, 249, 1);
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.67);
  color: #3672bf;
  margin-left: 20px;
  font-weight: bold;
  cursor: pointer;
  display: inline-block;
  float: right;
  font-size: 14px;
}

.next-btn {
  display: block;
  width: 400px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  background: rgba(54, 114, 191, 1);
  border-radius: 4px;
  color: #fff;
  border: none;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  margin: 0 auto;
}

.sed-register .forms {
  width: 520px;
}

.sed-register .forms input {
  width: 420px;
}

.success {
  margin-top: 60px;
}

.success p {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}

.success p.sucess-font {
  font-size: 16px;
  font-weight: 400;
  margin: 18px 0px;
}

.return-home {
  font-size: 14px;
  font-weight: bold;
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/hospital/register.vue